/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner } from './CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner';
import {
    CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerFromJSON,
    CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerFromJSONTyped,
    CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerToJSON,
} from './CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner';

/**
 * 
 * @export
 * @interface CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response
 */
export interface CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response {
    /**
     * API request succeeded
     * @type {boolean}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response
     */
    success: boolean;
    /**
     * An array of requested items
     * @type {Array<CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner>}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response
     */
    data: Array<CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner>;
    /**
     * Total number of items in the response
     * @type {number}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response
     */
    totalCount: number;
    /**
     * A token to retrieve the next page of items in the collection
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response
     */
    nextToken: string | null;
    /**
     * Whether there are more items in the collection
     * @type {boolean}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "nextToken" in value;
    isInstance = isInstance && "hasMore" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseFromJSON(json: any): CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response {
    return CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': ((json['data'] as Array<any>).map(CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerFromJSON)),
        'totalCount': json['total_count'],
        'nextToken': json['next_token'],
        'hasMore': json['has_more'],
    };
}

export function CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseToJSON(value?: CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'data': ((value.data as Array<any>).map(CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerToJSON)),
        'total_count': value.totalCount,
        'next_token': value.nextToken,
        'has_more': value.hasMore,
    };
}

